var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as _ from 'lodash';
var ProductsService = /** @class */ (function () {
    function ProductsService(api) {
        this.api = api;
    }
    // The method wchich is going to be called in the component to return all the options
    // It will call each private method as a chain and it returns a promise
    ProductsService.prototype.fetchAsyncFieldsOptions = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return _this.getProductStatuses()
                            .then(function (data) {
                            resolve(data);
                        })
                            .catch(function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    ProductsService.prototype.setDataToProductForm = function (updatedFormConfig, product) {
        _.set(updatedFormConfig, 'bg_name.value', product.BgName);
        _.set(updatedFormConfig, 'bg_name.touched', true);
        _.set(updatedFormConfig, 'bg_name.valid', true);
        _.set(updatedFormConfig, 'en_name.value', product.EnName);
        _.set(updatedFormConfig, 'en_name.touched', true);
        _.set(updatedFormConfig, 'en_name.valid', true);
        _.set(updatedFormConfig, 'bg_description.value', product.BgDescription);
        _.set(updatedFormConfig, 'bg_description.touched', true);
        _.set(updatedFormConfig, 'bg_description.valid', true);
        _.set(updatedFormConfig, 'en_description.value', product.EnDescription);
        _.set(updatedFormConfig, 'en_description.touched', true);
        _.set(updatedFormConfig, 'en_description.valid', true);
        _.set(updatedFormConfig, 'price.value', product.Price);
        _.set(updatedFormConfig, 'price.touched', true);
        _.set(updatedFormConfig, 'price.valid', true);
        _.set(updatedFormConfig, 'status.value', product.Status);
        _.set(updatedFormConfig, 'status.touched', true);
        _.set(updatedFormConfig, 'status.valid', true);
        _.set(updatedFormConfig, 'position.value', product.Position);
        _.set(updatedFormConfig, 'position.touched', true);
        _.set(updatedFormConfig, 'position.valid', true);
        _.set(updatedFormConfig, 'slug.value', product.Slug);
        _.set(updatedFormConfig, 'slug.touched', true);
        _.set(updatedFormConfig, 'slug.valid', true);
        _.set(updatedFormConfig, 'line_name.value', product.LineName);
        _.set(updatedFormConfig, 'line_name.touched', true);
        _.set(updatedFormConfig, 'line_name.valid', true);
        _.set(updatedFormConfig, 'bg_subhead.value', product.BgSubhead);
        _.set(updatedFormConfig, 'bg_subhead.touched', true);
        _.set(updatedFormConfig, 'bg_subhead.valid', true);
        _.set(updatedFormConfig, 'en_subhead.value', product.EnSubhead);
        _.set(updatedFormConfig, 'en_subhead.touched', true);
        _.set(updatedFormConfig, 'en_subhead.valid', true);
        _.set(updatedFormConfig, 'bg_usage.value', product.BgUsage);
        _.set(updatedFormConfig, 'bg_usage.touched', true);
        _.set(updatedFormConfig, 'bg_usage.valid', true);
        _.set(updatedFormConfig, 'en_usage.value', product.EnUsage);
        _.set(updatedFormConfig, 'en_usage.touched', true);
        _.set(updatedFormConfig, 'en_usage.valid', true);
        _.set(updatedFormConfig, 'bg_pao.value', product.BgPao);
        _.set(updatedFormConfig, 'bg_pao.touched', true);
        _.set(updatedFormConfig, 'bg_pao.valid', true);
        _.set(updatedFormConfig, 'en_pao.value', product.EnPao);
        _.set(updatedFormConfig, 'en_pao.touched', true);
        _.set(updatedFormConfig, 'en_pao.valid', true);
        // _.set(updatedFormConfig, 'composition.value', product.Composition);
        // _.set(updatedFormConfig, 'composition.touched', true);
        // _.set(updatedFormConfig, 'composition.valid', true);
        _.set(updatedFormConfig, 'bg_manufacturer_information.value', product.BgManufacturer);
        _.set(updatedFormConfig, 'bg_manufacturer_information.touched', true);
        _.set(updatedFormConfig, 'bg_manufacturer_information.valid', true);
        _.set(updatedFormConfig, 'en_manufacturer_information.value', product.EnManufacturer);
        _.set(updatedFormConfig, 'en_manufacturer_information.touched', true);
        _.set(updatedFormConfig, 'en_manufacturer_information.valid', true);
        _.set(updatedFormConfig, 'bg_features.value', product.BgFeatures);
        _.set(updatedFormConfig, 'bg_features.touched', true);
        _.set(updatedFormConfig, 'bg_features.valid', true);
        _.set(updatedFormConfig, 'en_features.value', product.EnFeatures);
        _.set(updatedFormConfig, 'en_features.touched', true);
        _.set(updatedFormConfig, 'en_features.valid', true);
        _.set(updatedFormConfig, 'youtube_url.value', product.YouTubeUrl);
        _.set(updatedFormConfig, 'youtube_url.touched', true);
        _.set(updatedFormConfig, 'youtube_url.valid', true);
        _.set(updatedFormConfig, 'option_type.value', product.OptionType);
        _.set(updatedFormConfig, 'option_type.touched', true);
        _.set(updatedFormConfig, 'option_type.valid', true);
        _.set(updatedFormConfig, 'option_type.elementConfig.readOnlyInput', true);
        _.set(updatedFormConfig, 'brand.value', product.BrandsFormatted);
        _.set(updatedFormConfig, 'brand.touched', true);
        _.set(updatedFormConfig, 'brand.valid', true);
        _.set(updatedFormConfig, 'categories.value', product.CategoriesFormatted);
        _.set(updatedFormConfig, 'categories.touched', true);
        _.set(updatedFormConfig, 'categories.valid', true);
        _.set(updatedFormConfig, 'brand_categories.value', product.BrandCategoriesFormatted);
        _.set(updatedFormConfig, 'brand_categories.touched', true);
        _.set(updatedFormConfig, 'brand_categories.valid', true);
        _.set(updatedFormConfig, 'product_label.value', product.ProductLabel);
        _.set(updatedFormConfig, 'product_label.touched', true);
        _.set(updatedFormConfig, 'product_label.valid', true);
        _.set(updatedFormConfig, 'promotion_percent_difference.value', product.PromotionPercentDifference);
        _.set(updatedFormConfig, 'promotion_percent_difference.touched', true);
        _.set(updatedFormConfig, 'promotion_percent_difference.valid', true);
        _.set(updatedFormConfig, 'meta_title.value', product.MetaTitle);
        _.set(updatedFormConfig, 'meta_title.touched', true);
        _.set(updatedFormConfig, 'meta_title.valid', true);
        _.set(updatedFormConfig, 'meta_description.value', product.MetaDescription);
        _.set(updatedFormConfig, 'meta_description.touched', true);
        _.set(updatedFormConfig, 'meta_description.valid', true);
        _.set(updatedFormConfig, 'bg_seo_description.value', product.BgDescriptionSEO);
        _.set(updatedFormConfig, 'bg_seo_description.touched', true);
        _.set(updatedFormConfig, 'bg_seo_description.valid', true);
        _.set(updatedFormConfig, 'en_seo_description.value', product.EnDescriptionSEO);
        _.set(updatedFormConfig, 'en_seo_description.touched', true);
        _.set(updatedFormConfig, 'en_seo_description.valid', true);
    };
    // Asynchronous getting of the statuses
    ProductsService.prototype.getProductStatuses = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return _this.api
                            .getProductsStatuses()
                            .then(function (response) {
                            var resolveData = {
                                statuses: response.data,
                            };
                            resolve(_this.getOptionTypes(resolveData));
                        })
                            .catch(function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    // Asynchronous getting of the option types
    ProductsService.prototype.getOptionTypes = function (resolveData) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return _this.api
                            .getOptionTypes()
                            .then(function (response) {
                            resolve(_this.getProductLabels(__assign(__assign({}, resolveData), { optionTypes: _.get(response, 'data', '') })));
                        })
                            .catch(function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    ProductsService.prototype.getProductLabels = function (resolveData) {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        return _this.api
                            .getProductLabels()
                            .then(function (response) {
                            resolve(__assign(__assign({}, resolveData), { productLabels: _.get(response, 'data', '') }));
                        })
                            .catch(function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    return ProductsService;
}());
export default ProductsService;



//////////////////
// WEBPACK FOOTER
// ./src/services/products.service.ts
// module id = 407
// module chunks = 0